import { render, staticRenderFns } from "./SignDocument.vue?vue&type=template&id=16bfd940&scoped=true"
import script from "./SignDocument.vue?vue&type=script&lang=js"
export * from "./SignDocument.vue?vue&type=script&lang=js"
import style0 from "./SignDocument.vue?vue&type=style&index=0&id=16bfd940&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bfd940",
  null
  
)

export default component.exports